<template>
    <div>
        <LoginComponent/>
    </div>
</template>

<script setup>
import LoginComponent from '@/components/LoginComponent/LoginComponent.vue';
history.forward()
</script>